
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__cms/[section]/[...slug]",
      function () {
        return require("private-next-pages/__cms/[section]/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__cms/[section]/[...slug]"])
      });
    }
  